import { fromUnixTime, isSameDay } from 'date-fns'

import { type Notification, InsightNotificationTypes } from '../types'

// Lazy-initialized set of insight notification type values for efficient filtering
let _insightNotificationTypeValues: Set<number> | null = null

export const getInsightNotificationTypeValues = (): Set<number> => {
  if (!_insightNotificationTypeValues) {
    _insightNotificationTypeValues = new Set(
      Object.values(InsightNotificationTypes).filter(
        (value) => typeof value === 'number',
      ) as number[],
    )
  }
  return _insightNotificationTypeValues
}

export const sortByDate = (a: Notification, b: Notification) => {
  return b.delivered_at - a.delivered_at
}

export const shouldShowDate = (index: number, notifications: Notification[]) => {
  const currentDate = fromUnixTime(notifications[index].delivered_at)
  const previousDate = fromUnixTime(notifications[index - 1]?.delivered_at)

  return !isSameDay(currentDate, previousDate)
}

export const hasInsetBorder = (index: number, notifications: Notification[]) => {
  const currentDate = fromUnixTime(notifications[index].delivered_at)
  const nextDate = fromUnixTime(notifications[index + 1]?.delivered_at)

  return isSameDay(currentDate, nextDate)
}

export function filterRecentNotifications(notifications: Notification[]): Notification[] {
  const THIRTY_DAYS_IN_SECONDS = 30 * 24 * 60 * 60
  const currentTime = Math.floor(Date.now() / 1000)

  return notifications.filter((notification: Notification) => {
    const deliveredAt = notification.delivered_at
    return currentTime - deliveredAt <= THIRTY_DAYS_IN_SECONDS
  })
}
